import React, { useEffect, useRef, useState } from "react";
import { authSession, setToken } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const ranRef = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { setErr("Missing session_id"); return; }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const user = await authSession(session_id);
        if (user.session_token) setToken(user.session_token);
        setUser(user);
        // Clear the hash and redirect to home
        window.history.replaceState({}, document.title, "/");
        window.location.replace("/");
      } catch (e) {
        setErr(e?.response?.data?.detail || e.message || "Auth failed");
      }
    })();
  }, [setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white">
      <div className="text-center">
        {err ? (
          <>
            <div className="text-[#FF3B30] font-mono text-sm mb-3">// Auth Error</div>
            <p className="text-zinc-400">{err}</p>
            <a href="/" className="inline-block mt-4 px-4 py-2 bg-white text-black rounded-sm text-sm">Back home</a>
          </>
        ) : (
          <>
            <Loader2 className="w-8 h-8 animate-spin text-[#00E676] mx-auto mb-3" />
            <p className="text-zinc-400 font-mono text-sm">// Establishing session…</p>
          </>
        )}
      </div>
    </div>
  );
}
